import { Box, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const YesNoDisplay = ({ value }: { value: boolean }) => {
	const { t } = useTranslation(['commonButton']);
	return (
		<Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
			<Switch checked={value} disabled size="small" />
			<span>{value ? t('commonButton:yes') : t('commonButton:no')}</span>
		</Box>
	);
};
